<template>
  <SessionLoadingScreen message="Sincronizando sesión…" />
</template>

<script>
import { ENDPOINT_SSO_CONSUME } from '@/config';
import { forceLogin } from '@/requests/ac';
import SessionLoadingScreen from '@/components/design/SessionLoadingScreen.vue';

const notifyParent = (type, ok = true) => {
  if (window.parent && window.parent !== window) {
    window.parent.postMessage({ type, ok }, '*');
  }
};

export default {
  name: 'SsoAccept',
  components: { SessionLoadingScreen },
  async created() {
    const code = this.$route.query.code;
    const next = this.$route.query.next || '/home/main';
    const inIframe = window.parent && window.parent !== window;

    if (!code) {
      notifyParent('ac-sso-ready', false);
      if (!inIframe) this.$router.replace({ name: 'login' });
      return;
    }

    try {
      const res = await fetch(ENDPOINT_SSO_CONSUME, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code }),
      });
      const data = await res.json();
      if (!res.ok || !data || !data.refresh) {
        throw new Error(data?.detail || 'SSO consume failed');
      }

      const { refresh, access, user } = data;
      forceLogin(refresh);
      this.$store.dispatch('assign', {
        key: 'access',
        val: { time: new Date().getTime(), status: 1, val: access },
      });
      this.$store.dispatch('set', { key: 'session', val: { refresh, access, user } });

      notifyParent('ac-sso-ready', true);
      if (!inIframe) {
        const target = next.startsWith('http') ? next : next;
        if (target.startsWith('http')) {
          window.location.href = target;
        } else {
          this.$router.replace(target);
        }
      }
    } catch (e) {
      console.error('SSO accept error', e);
      notifyParent('ac-sso-ready', false);
      if (!inIframe) this.$router.replace({ name: 'login' });
    }
  },
};
</script>
